
import i18n from '@/plugins/i18n';

export const tHeader = () => {
    return [
        i18n.t('Carrier'),
        i18n.t('Confirm Date'),
        i18n.t('Create Date'),
        i18n.t('Tracking Number'),
        i18n.t('Receiver'),
        i18n.t('Phone'),
        i18n.t('Address'),
        i18n.t('Cod Amount'),
        i18n.t('Cod Fee'),
        i18n.t('Remark'),
    ]
};

export const filterVal = () => {
    return [
        'name',
        'ra_confirm_date',
        'ra_create_date',
        'tracking_number',
        'fullname',
        'mobile',
        'full_address',
        'cod_amount',
        'cod_price',
        'is_deduct'
    ]
};

export const tHeaderShipping = () => {
    return [
        i18n.t('_ShippingChargeBillingReport.Carrier'),                  //0
        i18n.t('Tracking No.'),                                          //1
        i18n.t('_ShippingChargeBillingReport.Order No'),                 //2
        i18n.t('Orders Date'),                                           //3
        i18n.t('_ShippingChargeBillingReport.Receiver'),                 //4
        i18n.t('Phone Number'),                                          //5
        i18n.t('_ShippingChargeBillingReport.Receiver Address'),         //6
        i18n.t('Merchant Name'),                                         //7
        i18n.t('Shipping Status'),                                       //8
        i18n.t('_ShippingChargeBillingReport.Estimate Price'),           //9
        i18n.t('_ShippingChargeBillingReport.Actual Price'),             //10
        i18n.t('_ShippingChargeBillingReport.COD Amount'),               //11
        i18n.t('_ShippingChargeBillingReport.COD Fee'),                  //12
        i18n.t('Remote Area Fee'),                                       //13
        i18n.t('Tourism Price'),                                         //14
        i18n.t('Return Price'),                                          //15
        i18n.t('_ShippingChargeBillingReport.Total Estimate Shipping'),  //16
        i18n.t('_ShippingChargeBillingReport.Total Actual Shipping'),    //17
        i18n.t('_ShippingChargeBillingReport.Estimate Weight'),          //18
        i18n.t('_ShippingChargeBillingReport.Actual Weight'),            //19
        i18n.t('Box Size'),                                              //20
        i18n.t('_ShippingChargeBillingReport.Refund/Charge'),            //21
        i18n.t('_ShippingChargeBillingReport.Reference Tracking No'),    //22
        i18n.t('Shipping Date'),                                         //23
        i18n.t('Remark'),                                                //24
    ]
};

export const filterValShipping = () => {
    return [
        'name',                     //0
        'tracking_number',          //1
        'order_number',             //2
        'orders_date',              //3
        'fullname',                 //4
        'mobile',                   //5
        'full_address',             //6
        'merchant_name',            //7
        'shipping_status',          //8
        'estimate_price',           //9
        'actual_price',             //10
        'actual_cod_amount',        //11
        'actual_cod_fee',           //12
        'remote_area_price',        //13
        'tourism_price',            //14
        'return_fee',               //15
        'total_shipping_estimate',  //16
        'total_shipping',           //17
        'estimate_weight',          //18
        'actual_weight',            //19
        'box_size',                 //20
        'refund_charge',            //21
        'return_tracking_number',   //22
        'shipping_date',            //23
        'remark',                   //24
    ]
};



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/xlsx.js